import useScreenSize from '@utils/hooks/useScreenSize';

export const getNumberOfItemsPerRow = (width: number): number => {
    if (width >= 1400) return 10; // Extra Extra Large screens (>=1400px)
    if (width >= 1200) return 8; // Extra Large screens (>=1200px)
    if (width >= 768) return 6; // Medium screens (>=768px)
    if (width >= 576) return 4; // Small screens (>=576px)
    return 2; // Extra Small screens (<576px)
};

const useNumberOfItemsPerRow = () => {
    const {width} = useScreenSize();

    return getNumberOfItemsPerRow(width);
};

export default useNumberOfItemsPerRow;
